module.exports = __webpack_public_path__ + "img/hr-red-asterisk-06.3f4ea2d0.png";